import { render, staticRenderFns } from "./MonProfile.vue?vue&type=template&id=6cdfa367&"
import script from "./MonProfile.vue?vue&type=script&lang=js&"
export * from "./MonProfile.vue?vue&type=script&lang=js&"
import style0 from "./MonProfile.vue?vue&type=style&index=0&id=6cdfa367&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports